export const STATUS_INIT = 'init';
export const STATUS_SUCCESS = 'success';
export const STATUS_FAILURE = 'failure';
export const STATUS_SAVING = 'saving';
export const STATUS_SAVED = 'saved';
export const STATUS_INVITATIONS_SENT = 'invitations_sent';
export const STATUS_NO_INVITATIONS_SENT = 'no_invitations_sent';
export const STATUS_REDIRECT = 'redirect';



// WEBPACK FOOTER //
// ./src/constants/status.js